import { db } from "../plugins/firebase.js";

export const getUpdateInfo = async () => {
  const docs = db.collection("update_info").orderBy("updated_at", "desc");
  return await docs.get().then(snapshot => {
    let items = [];
    snapshot.docs.forEach(doc => {
      let info = doc.data();
      items.push(info);
    })
    return items;
  });
}

export const getLatestMusic = async () => {
  const docs = db.collection('update_info')
    .where('kind','==', 'Music')
    .orderBy('updated_at', 'desc')
    return await docs.get().then(snapshot => {
    let items = [];
    snapshot.docs.forEach(doc => {
      let info = doc.data();
      if(info.image != ""){
        items.push(info);
      }
    })
    return items;
  });
}